module.exports = __webpack_public_path__ + "static/color-logo-27ab946089ad1fb9804b8c08e21567df.png";